export default [
    {
        path: "/products",
        name: "products-list",
        component: () => import("@/views/product/products-list/ProductsList.vue"),
        meta:{
            action:"read",
            resource: "Auth",
        }
    },
    {
        path: "/product/hktv",
        name: "hktv-edit",
        component: () => import("@/views/tool/toolEdit.vue"),
        meta:{
            action:"read",
            resource: "Auth",
            navActiveLink: "products-list"
        }
    },
    {
        path: "/product/hktv-category",
        name: "hktv-category",
        component: () => import("@/views/product/hktv-category/Hktv.vue"),
        meta:{
            action:"read",
            resource: "users",
            navActiveLink: "products-list"
        }
    },
    // {
    //     path: "/product/edit/:id",
    //     name: "product-edit",
    //     component: () => import("@/views/product/products-edit/productsEdit.vue"),
    //     meta:{
    //         action:"read",
    //         resource: "Auth",
    //         navActiveLink: "products-list"
    //     }
    // }
]